import qweBaseField from "../BaseField"
import { qweIsEmpty } from '../../../common/commonHelper'
import { getData } from '../../../apis/httpHelper'
import shengJson from "../../../assets/data/sheng.json"
import autoPositionHelper from "./autoPositionHelper"

export default {
    data:function(){
        return {
            isPosition:false,
            isOnlyCascader:false,
            configData:{
                value:"value",
                label:"value",
                children:"children"
            },
            options:[],
            showValue:"定位中。。。。"
        }
    },
    addressOptions:[],
    created: async function(){
        this.isOnlyCascader = this.selfSetting.IsOnly;
        
        this.isPosition = this.selfSetting.IsPosition;
        if(this.isPosition){
            await autoPositionHelper.initInstance();
            let value = this.data[this.name];
            if(value.Cascader.length == 0){
                this.position();
            }
            else{
                let result = this.setValueBeforeHook(this.data[this.name]);
                let address = result.Cascader.join('') + result.Detail;
                if(!qweIsEmpty(address)){
                    this.showValue = address;
                }
            }
        }
        
        else{
            this.options = shengJson;
        }
    },
    computed:{
        valueString:function(){
            return JSON.stringify(this.data[this.name])
        }
    },
    mixins :[qweBaseField],
    methods:{
        position:function(){
            if(this.disabled){
                return;
            }
            this.showValue = "正在定位中···";
            let that = this;
            autoPositionHelper._aMapGeolocation.getCurrentPosition(function (status, result) {
                if (status === "complete") {
                    that.positionSuccess(result);
                }
                else if (status === "error") {
                    that.positionError(result);
                }
                else {
                    this.positionError({ message: "一些未知的错误，status" + status + ", result:" + JSON.stringify(result) })
                }
            });
        },

        positionSuccess: function (position) {
            if (position.addressComponent === undefined) {
                this.$message.error("定位异常，请联系管理员：" + position.message);
                this.showValue = "定位失败";
                return;
            }
            let result = position.addressComponent;
            let cascader = [result.province, result.city, result.district];
            let formattedAddress = position.formattedAddress;
            let cascaderString = cascader.join("");
            let detial = formattedAddress.replace(cascaderString, "");
            this.data[this.name] = { "Cascader": cascader, "Detail": detial }
            this.showValue = position.formattedAddress;
        },

        positionError: function (error) {
            this.$message.error(error.message);
            this.showValue = "定位失败";
        },

        updateCascader:function(val){
            this.data[this.name] = this.setValueBeforeHook(this.data[this.name]);
            this.data[this.name].Cascader = val;
        },

        updateDetail:function(val){
            this.data[this.name] = this.setValueBeforeHook(this.data[this.name]);
            this.data[this.name].Detail = (val || '').trim();
        },

        setValueBeforeHook: function (value) {
            if(value == null && value == undefined){
                return {
                    Cascader:[],
                    Detail:""
                }
            }
            if(value.hasOwnProperty("Cascader") && value.hasOwnProperty("Detail")){
                return value;
            }
            else{
                return {
                    Cascader:[],
                    Detail:""
                }
            }
        },

        buildRequiredRule:function(){
            let validatePass = (rule, value, callback) => {
                if (value === null || value === undefined) {
                    callback(new Error('当前字段必填'));
                } 
                else {
                    if(value.Cascader.length == 0){
                        callback(new Error('省市县必填'));
                        return;
                    }
                    if (qweIsEmpty(value.Detail)) {
                        callback(new Error('请填写具体地址'));
                        return;
                    }
                    callback();
                }
            };
            if(this.selfSetting.IsOnly){
                validatePass = (rule, value, callback) => {
                    if (value === null || value === undefined) {
                        callback(new Error('当前字段必填'));
                        return;
                    } 
                    else {
                        if(value.Cascader.length == 0){
                            callback(new Error('省市县必填'));
                            return;
                        }
                        callback();
                    }
                }
            }
            return {
                validator: validatePass, trigger: 'blur', required:true
            };
        }
    }
}